import React, { useEffect, useState } from 'react';
const STORAGE_KEY = 'matematica-pronta-scadenza-lancio';
const GIORNO_IN_MS = 24 * 60 * 60 * 1000;
interface TempoRimanente {
  ore: number;
  minuti: number;
  secondi: number;
}
export function AnnouncementBar() {
  const [tempo, setTempo] = useState<TempoRimanente>({
    ore: 24,
    minuti: 0,
    secondi: 0
  });
  useEffect(() => {
    const salvata = Number(window.localStorage.getItem(STORAGE_KEY));
    let scadenza = Number.isFinite(salvata) && salvata > Date.now() ? salvata : Date.now() + GIORNO_IN_MS;
    window.localStorage.setItem(STORAGE_KEY, String(scadenza));
    const aggiorna = () => {
      const adesso = Date.now();
      if (scadenza <= adesso) {
        scadenza = adesso + GIORNO_IN_MS;
        window.localStorage.setItem(STORAGE_KEY, String(scadenza));
      }
      const secondiTotali = Math.max(0, Math.ceil((scadenza - adesso) / 1000));
      setTempo({
        ore: Math.floor(secondiTotali / 3600),
        minuti: Math.floor(secondiTotali % 3600 / 60),
        secondi: secondiTotali % 60
      });
    };
    aggiorna();
    const intervallo = window.setInterval(aggiorna, 1000);
    return () => window.clearInterval(intervallo);
  }, []);
  return <aside className="sticky top-0 z-50 flex h-8 w-full items-center justify-center bg-brand-blue px-2 text-white shadow-sm" data-id="element-16" data-mp="3sfzxm06ijg9s">
      <div className="flex items-center gap-2 sm:gap-3" data-id="element-17" data-mp="19ym5qimyknm">
        <p className="whitespace-nowrap text-[9px] font-extrabold tracking-wide sm:text-[10px]" data-id="element-18" data-mp="oyzyhoulafy6">
          <span className="hidden sm:inline" data-id="element-19" data-mp="txl09sphp7oq">
            ★ OFFERTA DI LANCIO A TEMPO LIMITATO — PRENDI MATEMATICA PRONTA PRIMA CHE IL PREZZO AUMENTI ·{' '}
          </span>
          TERMINA TRA:
        </p>
        <div className="flex items-center gap-1 font-mono" aria-label={`Mancano ${tempo.ore} ore, ${tempo.minuti} minuti e ${tempo.secondi} secondi`} data-id="element-20" data-mp="k7hwcxgty9bm">
          <UnitaTimer valore={tempo.ore} etichetta="ORE" data-id="element-21" data-mp="1coc3ecivw1uo" />
          <span className="text-xs font-bold" data-id="element-22" data-mp="1cpwzw7orduv6">:</span>
          <UnitaTimer valore={tempo.minuti} etichetta="MIN" data-id="element-23" data-mp="1mk2mzfw27iyc" />
          <span className="text-xs font-bold" data-id="element-24" data-mp="1mi89gmn4at4a">:</span>
          <UnitaTimer valore={tempo.secondi} etichetta="SEC" data-id="element-25" data-mp="1hkycmlxeff6f" />
        </div>
      </div>
    </aside>;
}
function UnitaTimer({
  valore,
  etichetta
}: {
  valore: number;
  etichetta: string;
}) {
  return <span className="whitespace-nowrap text-[11px] font-extrabold sm:text-xs" data-id="element-26" data-mp="18lb7pq5gnr8m">
      {String(valore).padStart(2, '0')}
      <span className="ml-0.5 text-[8px] font-bold text-white/70" data-id="element-27" data-mp="13m8bmv7gkvcs">{etichetta}</span>
    </span>;
}